// Permissions
export enum CompanyUserPermissions {
    ViewCompanyDetails = 1,
    EditCompanyDetails = 3,
    ViewCompanyBranches = 11,
    CreateCompanyBranches = 12,
    EditCompanyBranches = 13,
    ViewUsersStaff = 21,
    EditUsersStaff = 23,
    ManageInvitationsUserStaff = 27,
    ViewCompanyRoles = 31,
    AssignCompanyRoles = 32,
    ManageCompanyRoles = 33,
    ViewActivity = 40,
}

export enum OmeUserPermissions {
    ViewOmePropertiesDepositReplacement = 1001,
    ManageOmePropertiesDepositReplacement = 1002,
    DeleteOmePropertiesDepositReplacement = 1003,
}

export enum InternalUserPermissions {
    ViewCustomerUsersUsers = 1100,
    EditCustomerUserUsers = 1102,
    AssignNewCustomerTypeUsers = 1103,
    CreateNewCustomerUserUsers = 1104,
    DeactivateActivateCustomerUserUsers = 1105,
    DeleteCustomerUserUsers = 1106,
    SuspendCustomerUserUsers = 1107,
    ViewCompaniesBusinesses = 1200,
    EditCompanyDetailsBusinesses = 1202,
    UpdateTermsAndConditionsPortalSettings = 1301,
    ViewPortalSettings = 1390,
    ViewInternalUsersAdminUsers = 1400,
    ViewSelectedInternalUserAdminUsers = 1401,
    InviteInternalUsersAdminUsers = 1402,
    DeleteInvitedInternalUserAdminUsers = 1403,
    EditInternalUserAdminUsers = 1404,
    DeleteInternalUserAdminUsers = 1405,
    DeactivateActivateInternalUserUsers = 1406,
    ViewRolesRolesAndPermissions = 1500,
    ManageRolesRolesAndPermissions = 1501,
    ViewActivity = 1600,
}

// Common groups of permissions
// Internal
export const viewCustomerUserInternalPermissions = {
    isTolerant: true,
    permissions: [
        InternalUserPermissions.ViewCustomerUsersUsers,
        InternalUserPermissions.EditCustomerUserUsers,
        InternalUserPermissions.DeactivateActivateCustomerUserUsers,
        InternalUserPermissions.CreateNewCustomerUserUsers,
        InternalUserPermissions.DeleteCustomerUserUsers,
    ],
};

export const viewInternalUserInternalPermissions = {
    isTolerant: true,
    permissions: [
        InternalUserPermissions.ViewSelectedInternalUserAdminUsers,
        InternalUserPermissions.EditInternalUserAdminUsers,
        InternalUserPermissions.DeactivateActivateInternalUserUsers,
        InternalUserPermissions.DeleteInternalUserAdminUsers,
    ],
};

export const viewCompanyDetailsInternalPermissions = {
    isTolerant: true,
    permissions: [
        InternalUserPermissions.ViewCompaniesBusinesses,
        InternalUserPermissions.EditCompanyDetailsBusinesses,
    ],
};

// Company
